import { Descriptions } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { getAward } from '../../../api/award.api';
import Button from '../../../components/Button';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import { IGetAward } from '../../../models/award.model';

interface IMatch {
  awardCode: string;
}

const ProgramAwardRead = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const match = useRouteMatch<IMatch>();
  const awardCode = match.params.awardCode;
  const { data: res, isLoading, error, execute } = useAxios<IGetAward>();

  useEffect(() => {
    if (awardCode) {
      execute(getAward(awardCode));
    }
  }, [awardCode]);

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        parentMenu={t('program.award.title1')}
        currentMenu={t('program.award.title3')}
        iconFile="icon-program-big.svg"
      />
      <div className="comm-table__area rowType">
        <Descriptions
          bordered
          size="small"
          column={1}
          labelStyle={{ width: '25%' }}
        >
          <Descriptions.Item label="CODE">
            {res?.data?.awardCode}
          </Descriptions.Item>
          <Descriptions.Item label={t('program.award.column1')}>
            {res?.data?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Description (KO)">
            {res?.data?.descriptionKor}
          </Descriptions.Item>
          <Descriptions.Item label="Description (EN)">
            {res?.data?.descriptionEng}
          </Descriptions.Item>
          <Descriptions.Item label={t('program.award.column4')}>
            {res?.data?.useYN === 'Y' ? t('common.option.yes') : t('common.option.no')}
          </Descriptions.Item>
        </Descriptions>
        <div className="comm-bx__between">
          <div className="comm-btn__area">
            <Button
              className="btn-basic gray-line"
              onClick={() => history.push('/program/award')}
              text={t('common.button.list')}
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink-line"
              onClick={() => history.push(`/program/award/${awardCode}/edit`)}
              text={t('common.button.edit')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramAwardRead;
